export const checkPhone = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('手机号不能为空'));
	} else {
		const reg = /^1[3-9]\d{9}$/
		if (reg.test(value)) {
			callback();
		} else {
			return callback(new Error('请输入正确的手机号'));
		}
	}
	
};

export const checkIdCard = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('身份证号不能为空'));
	} else {
		const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
		
		if (reg.test(value)) {
			callback();
		} else {
			return callback(new Error('请输入正确的身份证号'));
		}
	}
	
	
};

export const checkRegion = function (rule, value, callback) {
	if(Array.isArray(value)){
		if(value.length == 0){
			return callback(new Error('所属省市不能为空'));
		}
		
		for(let i=0; i<value.length; i++){
			if(!value[i]){
				return callback(new Error('所属省市不能为空'));
			}
		}
		callback();
	}else{
		return callback(new Error('所属省市不能为空'));
	}
}
export function checkPrices(rule, value, callback) {
    if (rule.required === false && (value === '' || value === null || value === undefined)) {
        callback()
    }
    const isPrice = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
    if (isPrice.test(value)) {
        callback()
    } else {
        return callback(new Error(rule.message || '请输入正确的价格，例：10, 10.00'))
    }
}

export const checkEmail = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('邮箱不能为空'));
	} else {
		const reg = /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
		
		if (reg.test(value)) {
			callback();
		} else {
			return callback(new Error('请输入正确的邮箱'));
		}
	}
	
	
};
export const checkPassWord = (rule, value, callback) => {
	if (!value) {
		return callback(new Error("密码不能为空"));
	} else {
		//					const reg = /^(?![^a-zA-Z]+$)(?!\\D+$).{6,16}$/
		const reg =
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{8,32}$/;
		if (reg.test(value)) {
			callback();
		} else {
			//						return callback(new Error('请输入6到18位密码，同时包含字母和数字，且不能包含空格'));
			return callback(
				new Error(
					"请输入8到32位密码，同时包含大写字母、小写字母，数字和特殊字符，且不能包含空格"
				)
			);
		}
	}


};

export const checkLoginName = (rule, value, callback) => {
	if (!value) {
		return callback(new Error("登录账号不能为空"));
	} else {
		//					const reg = /^(?![^a-zA-Z]+$)(?!\\D+$).{6,16}$/
		const reg =
			/^[^\u4e00-\u9fa5]+$/;
		if (reg.test(value)) {
			callback();
		} else {
			//						return callback(new Error('请输入6到18位密码，同时包含字母和数字，且不能包含空格'));
			return callback(
				new Error(
					"登录账号不能包含中文汉字"
				)
			);
		}
	}


};